//
// ProceduralQuery.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../QueryBase";
import "./ProceduralData";
import "./ArgumentBase";

var ProceduralQuery = createModule("BIRD::ProceduralQuery", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::QueryBase"], EventDispatcher, [
    ,
    {
        generatedResources: [1],
        argumentList: [1],
        scoreCodeNumber: 4,
        referenceResources: [1],
        type: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ProceduralQuery;
